import AxiosService from './Axios.service';
import Config from '../config';
export {Api} from './Api.service';
export const Axios = {
    Server: new AxiosService(Config.ServerUrl),
    Api: new AxiosService(Config.ApiUrl)
}




// WEBPACK FOOTER //
// ./src/services/index.js